<utclub-modal title="Fatura Gonder" [buttons]="buttons">
    <utclub-formly [form]="form" [fields]="formFields" [model]="model">
    </utclub-formly>
</utclub-modal>